import { useSearchParams } from 'react-router-dom'
import { useGameStore } from '@/store/gameStore'
import { PageShell } from '../components/PageShell'
import { PageTabs } from '../components/PageTabs'
import { FeatureGate } from '../components/FeatureGate'
import { BroadcastHeader } from '../components/broadcast'
import { getClubHero } from '@/config/campusConfig'
import { FEATURES } from '@/config/clubLevelConfig'
import { BuildTabContent } from '../panels/BuildTab'
import { BuildingsTabContent } from '../panels/BuildingsTab'
import { UpgradesTabContent } from '../panels/UpgradesTab'
import { MaintenanceTabContent } from '../panels/MaintenanceTab'
import { CircleDot, Building2, ArrowUpCircle, Wrench, Compass } from 'lucide-react'

const TAB_KEYS = ['pistas', 'edificios', 'mejoras', 'mantenimiento'] as const

export function FacilitiesPage() {
  const courts = useGameStore(s => s.courts)
  const buildings = useGameStore(s => s.buildings)
  const clubLevel = useGameStore(s => s.clubLevel)
  const outdoor = courts.filter(c => c.type === 'outdoor').length
  const indoor = courts.filter(c => c.type === 'indoor').length

  // URL-driven tabs so campus cards can deep-link to the exact section
  const [params, setParams] = useSearchParams()
  const active = Math.max(0, TAB_KEYS.indexOf(params.get('tab') as (typeof TAB_KEYS)[number]))
  const handleTabChange = (i: number) => {
    setParams(p => { p.set('tab', TAB_KEYS[i] ?? TAB_KEYS[0]); return p }, { replace: true })
  }
  return (
    <PageShell
      pageId="facilities"
      title="Planos del Club"
      icon={<Compass size={22} />}
      backgroundImage={getClubHero(clubLevel).image}
    >
      <BroadcastHeader
        title="Obras del club"
        competition="Instalaciones"
        icon={Building2}
        meta={
          <>
            <span className="chip-angled tone-gold">{outdoor} outdoor</span>
            <span className="chip-angled">{indoor} indoor</span>
            <span className="chip-angled">{buildings.length} edificios</span>
          </>
        }
      />
      <PageTabs
        activeTab={active}
        onTabChange={handleTabChange}
        tabs={[
          {
            label: 'Pistas',
            icon: <CircleDot size={16} />,
            content: <BuildTabContent />,
          },
          {
            label: 'Edificios',
            icon: <Building2 size={16} />,
            content: <BuildingsTabContent />,
          },
          {
            label: 'Mejoras',
            icon: <ArrowUpCircle size={16} />,
            content: <FeatureGate feature={FEATURES.COURT_UPGRADES}><UpgradesTabContent /></FeatureGate>,
          },
          {
            label: 'Mantenimiento',
            icon: <Wrench size={16} />,
            content: <MaintenanceTabContent />,
          },
        ]}
      />
    </PageShell>
  )
}
